import styled from 'styled-components';

import { MEDIA_LARGE, MEDIA_MEDIUM } from './constants';

export const OnlyOnSmall = styled.div`
  display: block;

  ${MEDIA_MEDIUM} {
    display: none;
  }
`;

export const NotOnSmall = styled.div`
  display: none;

  ${MEDIA_MEDIUM} {
    display: block;
  }
`;

export const OnlyOnLarge = styled.div`
  display: none;

  ${MEDIA_LARGE} {
    display: block;
  }
`;

export const NotOnLarge = styled.div`
  display: block;

  ${MEDIA_LARGE} {
    display: none;
  }
`;
